import React, {useEffect, useRef, useState} from "react"
import {NavLink, useNavigate, useParams} from "react-router-dom"

import "./Test.css"
import {getCode, getDateString, retrieveData, sendRequest} from "../../common";


function TestResult({id}) {
	const navigate = useNavigate()
	// const {id} = useParams()

	const [applyTest, setApplyTest] = useState([])

	const getApplyTest = (id) => {
		sendRequest(`test/apply-test/${id}/`, 'GET', null, data => {
			setApplyTest(data)
		})
	}

	useEffect(() => {
		getApplyTest(id)
	}, [id])

	const windowWidth = useRef(window.innerWidth);
	const width = 1030//windowWidth?.current * 0.9
	const height = width * 1095 / 800

	const getColor = (alphabet) => {
		switch (alphabet) {
			case 'T':
			case 'F':
				return 'skyBlue'
			case 'S':
			case 'N':
				return 'purple'
		}
	}

	const isShape = applyTest?.test?.name?.indexOf('도형심리') !== -1

	const getColorClass = (stepIndex) => {
		if(isShape) {
			switch (stepIndex) {
				case 0:
					return 'green'
				case 1:
					return 'orange'
			}
		} else {
			switch (stepIndex) {
				case 0:
					return 'green'
				case 1:
					return 'purple'
				case 2:
					return 'skyBlue'
				case 3:
					return 'orange'
				case 4:
					return 'pink'
			}
		}
	}

	// if (!applyTest?.result?.diaShape?.length) {
	// 	console.log(applyTest?.result?.isBigAlphabet)
	// }

	return (
		<div className={'testResult'}>
				<div style={{paddingLeft: 10}}>
					<div style={{height: height + 70}}>
							<div style={{paddingTop: 50, width, height}}>
								<img src={isShape ? require('../../assets/results/shapeMain.png') : require('../../assets/results/main.png')} style={{width, height, position: 'absolute'}}/>
							</div>
					</div>
					<div style={{height: height + 70}}>
						{!isShape ?
							<div style={{paddingTop: 50, width, height}}>
								<img src={require('../../assets/results/result1.png')} style={{width, height, position: 'absolute'}}/>
								<div style={{width, marginTop: height * 0.105, marginLeft: width * 0.18, fontSize: 20, fontWeight: '700'}}>
									<div style={{position: 'absolute'}}>{applyTest?.name}</div>
									<div style={{position: 'absolute', left: width * 0.4}}>{applyTest?.birth}</div>
									<div style={{position: 'absolute', marginTop: -10, left: width * (applyTest?.gender === '남성' ? 0.615 : 0.655), fontSize: 30}}>V</div>
									<div style={{position: 'absolute', left: width * 0.855}}>{applyTest?.user?.name}</div>
								</div>
								<div style={{width, marginTop: height * 0.65, fontSize: 18, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.338}}>{applyTest?.result?.isBigWord[0]}</div>
									<div style={{position: 'absolute', left: width * 0.465}}>{applyTest?.result?.isBigWord[1]}</div>
									<div style={{position: 'absolute', left: width * 0.595}}>{applyTest?.result?.isBigWord[2]}</div>
									<div style={{position: 'absolute', left: width * 0.723}}>{applyTest?.result?.isBigWord[3]}</div>
									<div style={{position: 'absolute', left: width * 0.853}}>{applyTest?.result?.isBigWord[4]}</div>
								</div>
								<div style={{width, marginTop: height * 0.679, fontSize: 18, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.35}}>{applyTest?.result?.isBigAlphabet[0]}</div>
									<div style={{position: 'absolute', left: width * 0.475}}>{applyTest?.result?.isBigAlphabet[1]}</div>
									<div style={{position: 'absolute', left: width * 0.605}}>{applyTest?.result?.isBigAlphabet[2]}</div>
									<div style={{position: 'absolute', left: width * 0.734}}>{applyTest?.result?.isBigAlphabet[3]}</div>
									<div style={{position: 'absolute', left: width * 0.866}}>{applyTest?.result?.isBigAlphabet[4]}</div>
								</div>
								<div style={{width, marginTop: height * 0.71, fontSize: 16, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.29, width: width * 0.12 }} align={'center'}>{applyTest?.result?.top[0]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.42, width: width * 0.12}} align={'center'}>{applyTest?.result?.top[1]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.55, width: width * 0.12}} align={'center'}>{applyTest?.result?.top[2]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.68, width: width * 0.12}} align={'center'}>{applyTest?.result?.top[3]?.answer?.name}</div>
								</div>
								<div style={{width, marginTop: height * 0.739, fontSize: 16, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.29, width: width * 0.12}} align={'center'}>{applyTest?.result?.bottom[0]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.42, width: width * 0.12}} align={'center'}>{applyTest?.result?.bottom[1]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.55, width: width * 0.12}} align={'center'}>{applyTest?.result?.bottom[2]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.68, width: width * 0.12}} align={'center'}>{applyTest?.result?.bottom[3]?.answer?.name}</div>
								</div>
							</div>
							:
							<div style={{paddingTop: 50, width, height}}>
								<img src={require('../../assets/results/result12.png')} style={{width, height, position: 'absolute'}}/>
								<div style={{width, marginTop: height * 0.105, marginLeft: width * 0.173, fontSize: 20, fontWeight: '700'}}>
									<div style={{position: 'absolute'}}>{applyTest?.name}</div>
									<div style={{position: 'absolute', left: width * 0.392}}>{applyTest?.birth}</div>
									<div style={{position: 'absolute', marginTop: -10, left: width * (applyTest?.gender === '남성' ? 0.605 : 0.655), fontSize: 30}}>V</div>
									<div style={{position: 'absolute', left: width * 0.85}}>{applyTest?.user?.name}</div>
								</div>

								<div style={{width, marginTop: height * (0.368 - applyTest?.result?.vertical * 0.0055), fontSize: 20, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * (0.497 - applyTest?.result?.horizontal * 0.0078), fontSize: 20, color: 'red'}}>⬤</div>
								</div>

								<div style={{width, marginTop: height * 0.683, fontSize: 20, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.356}}>{applyTest?.result?.isBigWord[0]}</div>
									<div style={{position: 'absolute', left: width * 0.516}}>{applyTest?.result?.isBigWord[1]}</div>
									<div style={{position: 'absolute', left: width * 0.68}}>{applyTest?.result?.persona[0]}</div>
									<div style={{position: 'absolute', left: width * 0.836}}>{applyTest?.result?.persona[1]}</div>
								</div>
								<div style={{width, marginTop: height * 0.713, fontSize: 20, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.366}}>{applyTest?.result?.isBigAlphabet[0]}</div>
									<div style={{position: 'absolute', left: width * 0.526}}>{applyTest?.result?.isBigAlphabet[1]}</div>
									<div style={{position: 'absolute', left: width * 0.615, width: width * 0.16}} align={'center'}>{applyTest?.result?.personaWords[0][0]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.775, width: width * 0.16}} align={'center'}>{applyTest?.result?.personaWords[1][0]?.answer?.name}</div>
								</div>
								<div style={{width, marginTop: height * 0.7425, fontSize: 20, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.29, width: width * 0.16}} align={'center'}>{applyTest?.result?.top[0]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.452, width: width * 0.16}} align={'center'}>{applyTest?.result?.top[1]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.615, width: width * 0.16}} align={'center'}>{applyTest?.result?.personaWords[0][1]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.775, width: width * 0.16}} align={'center'}>{applyTest?.result?.personaWords[1][1]?.answer?.name}</div>
								</div>
								<div style={{width, marginTop: height * 0.772, fontSize: 20, fontWeight: '700'}}>
									<div style={{position: 'absolute', left: width * 0.29, width: width * 0.16}} align={'center'}>{applyTest?.result?.bottom[0]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.452, width: width * 0.16}} align={'center'}>{applyTest?.result?.bottom[1]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.615, width: width * 0.16}} align={'center'}>{applyTest?.result?.personaWords[0][2]?.answer?.name}</div>
									<div style={{position: 'absolute', left: width * 0.775, width: width * 0.16}} align={'center'}>{applyTest?.result?.personaWords[1][2]?.answer?.name}</div>
								</div>
							</div>
						}
					</div>

					<div style={{height: height + 70}}>
						<div style={{paddingTop: 40, width, height, position: 'absolute'}}>
							<img src={isShape ? require(`../../assets/results/result13.png`) : require(`../../assets/results/result9.png`)} style={{width, height, position: 'absolute'}}/>
						</div>
					</div>

					{applyTest?.result?.steps?.slice(0, (isShape ? 2 : 4)).map((item, index) => {
						const answerReplies = item?.answerReplies
						const imageIndex = index !== 1 ? index : isShape ? 8 : 1

						return (
							<div style={{height: height + 70}}>
								<div style={{paddingTop: 30, width, height, position: 'absolute', fontWeight: '700'}}>
									<img src={require(`../../assets/results/result${imageIndex+2}.png`)} style={{width, height, position: 'absolute', marginLeft: index === 0 ? 0 : 7}}/>

									<div style={{fontSize: 40, fontWeight: '700', position: 'absolute', top: 310, left: 145}}>{applyTest?.result?.isBigWord[index]}({applyTest?.result?.isBigAlphabet[index]})</div>

									<div className={`${answerReplies[0]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.162, left: width * 0.428, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[0]?.answer.name}
									</div>

									<div className={`${answerReplies[1]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.24, left: width * 0.348, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[1]?.answer.name}
									</div>
									<div className={`${answerReplies[2]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.24, left: width * 0.506, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[2]?.answer.name}
									</div>

									<div className={`${answerReplies[3]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.316, left: width * 0.27, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[3]?.answer.name}
									</div>
									<div className={`${answerReplies[4]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.316, left: width * 0.426, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[4]?.answer.name}
									</div>
									<div className={`${answerReplies[5]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.316, left: width * 0.583, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[5]?.answer.name}
									</div>

									<div className={`${answerReplies[6]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.395, left: width * 0.194, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[6]?.answer.name}
									</div>
									<div className={`${answerReplies[7]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.395, left: width * 0.35, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[7]?.answer.name}
									</div>
									<div className={`${answerReplies[8]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.395, left: width * 0.508, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[8]?.answer.name}
									</div>
									<div className={`${answerReplies[9]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.395, left: width * 0.665, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[9]?.answer.name}
									</div>

									<div className={`${answerReplies[10]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.473, left: width * 0.112, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[10]?.answer.name}
									</div>
									<div className={`${answerReplies[11]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.473, left: width * 0.27, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[11]?.answer.name}
									</div>
									<div className={`${answerReplies[12]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.473, left: width * 0.428, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[12]?.answer.name}
									</div>
									<div className={`${answerReplies[13]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.473, left: width * 0.585, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[13]?.answer.name}
									</div>
									<div className={`${answerReplies[14]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.473, left: width * 0.741, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[14]?.answer.name}
									</div>

									<div className={`${answerReplies[15]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.55, left: width * 0.112, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[15]?.answer.name}
									</div>
									<div className={`${answerReplies[16]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.55, left: width * 0.27, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[16]?.answer.name}
									</div>
									<div className={`${answerReplies[17]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.55, left: width * 0.428, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[17]?.answer.name}
									</div>
									<div className={`${answerReplies[18]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.55, left: width * 0.585, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[18]?.answer.name}
									</div>
									<div className={`${answerReplies[19]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.55, left: width * 0.741, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[19]?.answer.name}
									</div>

									<div className={`${answerReplies[20]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.628, left: width * 0.194, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[20]?.answer.name}
									</div>
									<div className={`${answerReplies[21]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.628, left: width * 0.35, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[21]?.answer.name}
									</div>
									<div className={`${answerReplies[22]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.628, left: width * 0.508, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[22]?.answer.name}
									</div>
									<div className={`${answerReplies[23]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.628, left: width * 0.665, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[23]?.answer.name}
									</div>

									<div className={`${answerReplies[24]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.707, left: width * 0.27, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[24]?.answer.name}
									</div>
									<div className={`${answerReplies[25]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.707, left: width * 0.426, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[25]?.answer.name}
									</div>
									<div className={`${answerReplies[26]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.707, left: width * 0.583, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[26]?.answer.name}
									</div>

									<div className={`${answerReplies[27]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.784, left: width * 0.349, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[27]?.answer.name}
									</div>
									<div className={`${answerReplies[28]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.784, left: width * 0.507, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[28]?.answer.name}
									</div>

									<div className={`${answerReplies[29]?.answer?.isBig ? 'big-' : ''}${getColorClass(index)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.862, left: width * 0.428, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
										{answerReplies[29]?.answer.name}
									</div>

								</div>
							</div>
						)
					})}

					{applyTest?.result?.steps?.length > 4 ?
						<div style={{height: height + 70}}>
							<div style={{paddingTop: 30, width, height, position: 'absolute', fontWeight: '700'}}>
								<img src={require(`../../assets/results/result${6}.png`)} style={{width, height, position: 'absolute'}}/>

								<div style={{fontSize: 40, fontWeight: '700', position: 'absolute', top: 310, left: 140}}>{applyTest?.result?.isBigWord[4]}({applyTest?.result?.isBigAlphabet[4]})</div>

								<div className={`${applyTest?.result?.steps[4]?.answerReplies[0]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.161, left: width * 0.449, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[0]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.steps[4]?.answerReplies[1]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.241, left: width * 0.369, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[1]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[2]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.241, left: width * 0.529, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[2]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.steps[4]?.answerReplies[3]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.321, left: width * 0.291, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[3]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[4]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.321, left: width * 0.45, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[4]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[5]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.321, left: width * 0.609, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[5]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.steps[4]?.answerReplies[6]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.401, left: width * 0.212, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[6]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[7]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.401, left: width * 0.371, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[7]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[8]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.401, left: width * 0.531, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[8]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[9]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.401, left: width * 0.69, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[9]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.steps[4]?.answerReplies[10]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.481, left: width * 0.291, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[10]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[11]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.481, left: width * 0.45, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[11]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[12]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.481, left: width * 0.609, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[12]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.steps[4]?.answerReplies[13]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.562, left: width * 0.369, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[13]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.steps[4]?.answerReplies[14]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.562, left: width * 0.529, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[14]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.steps[4]?.answerReplies[15]?.answer?.isBig ? 'big-' : ''}${getColorClass(4)} box`} style={{fontSize: 20, position: 'absolute', top: height * 0.642, left: width * 0.45, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019}} >
									{applyTest?.result?.steps[4]?.answerReplies[15]?.answer.name}
								</div>

							</div>
						</div>

						: null
					}
					{applyTest?.result?.steps?.length > 4 ?
						<div style={{height: height + 70}}>
							<div style={{paddingTop: 30, width, height, position: 'absolute', fontWeight: '700'}}>
								<img src={require(`../../assets/results/result7.png`)} style={{width, height, position: 'absolute'}}/>

								<div style={{fontSize: 30, fontWeight: '700', position: 'absolute', top: 405, left: 500}}>{applyTest?.result?.functions[0]}</div>
								<div style={{fontSize: 30, fontWeight: '700', position: 'absolute', top: 655, left: 120}}>{applyTest?.result?.functions[1]}</div>
								<div style={{fontSize: 30, fontWeight: '700', position: 'absolute', top: 655, right: 125}}>{applyTest?.result?.functions[2]}</div>
								<div style={{fontSize: 30, fontWeight: '700', position: 'absolute', top: 1330, left: 500}}>{applyTest?.result?.functions[3]}</div>

								<div className={`${applyTest?.result?.diaShape[0]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[0])} box`} style={{top: height * 0.319, left: width * 0.43, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[0]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[1]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[0])} box`} style={{top: height * 0.395, left: width * 0.355, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[1]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[2]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[0])} box`} style={{top: height * 0.395, left: width * 0.505, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[2]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.diaShape[3]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[1])} box`} style={{top: height * 0.507, left: width * 0.204, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[3]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[4]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[1])} box`} style={{top: height * 0.583, left: width * 0.204, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[4]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.diaShape[5]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[2])} box`} style={{top: height * 0.507, left: width * 0.655, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[5]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[6]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[2])} box`} style={{top: height * 0.583, left: width * 0.655, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[6]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.diaShape[9]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[3])} box`} style={{top: height * 0.698, left: width * 0.355, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[9]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[8]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[3])} box`} style={{top: height * 0.698, left: width * 0.505, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[8]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[7]?.answer?.isBig ? 'big-' : ''}${getColor(applyTest?.result?.diaAlphabets[3])} box`} style={{top: height * 0.773, left: width * 0.43, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[7]?.answer.name}
								</div>

								<div className={`${applyTest?.result?.diaShape[10]?.answer?.isBig ? 'big-' : ''}green box`} style={{top: height * 0.47, left: width * 0.43, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[10]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[11]?.answer?.isBig ? 'big-' : ''}green box`} style={{top: height * 0.545, left: width * 0.355, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[11]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[12]?.answer?.isBig ? 'big-' : ''}green box`} style={{top: height * 0.545, left: width * 0.505, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[12]?.answer.name}
								</div>
								<div className={`${applyTest?.result?.diaShape[13]?.answer?.isBig ? 'big-' : ''}green box`} style={{top: height * 0.622, left: width * 0.43, width: width * 0.15, height: height * 0.074, borderRadius: width * 0.019, fontSize: 20}}>
									{applyTest?.result?.diaShape[13]?.answer.name}
								</div>
							</div>
						</div>
						: null
					}

					<div style={{height: height + 70}}>
						<div style={{paddingTop: 40, width, height, position: 'absolute'}}>
							<img src={isShape ? require(`../../assets/results/result11.png`) : require(`../../assets/results/result8.png`)} style={{width, height, position: 'absolute'}}/>
						</div>
					</div>
				</div>
			{/*<ResultNav type={applyTest?.test?.type + ' 결과'}/>*/}
			{/*windowWidth?.current * 0.0*/}
			{/*<Footer />*/}
		</div>
	)
}

export default TestResult
